import React, {useState, useEffect} from 'react'
import styled from 'styled-components'
import MediaQuery from 'react-responsive'
import {SearchInput} from '../SearchInput/SearchInput'
import {fetchSearchResults} from '../../utils/search'
import {useDebounce} from 'use-debounce'
import Modal from 'react-modal'
import SearchResult from './SearchResult/SearchResult'
import {useUIDispatch} from '../../context/UIContext'
import {_L, useLocaleState} from '../../context/LocaleContext'
import {useViewFetch} from '../../utils/fetch'
import {fetchBuildings} from '../../utils/buildings'

function ReactModalAdapter({className, ...props}) {
  const contentClassName = `${className}__content`
  const overlayClassName = `${className}__overlay`
  const ContentId = 'modalContent'
  return (
    <Modal
      id={ContentId}
      portalClassName={className}
      className={contentClassName}
      overlayClassName={overlayClassName}
      {...props}
    />
  )
}

const StyledModal = styled(ReactModalAdapter)`
  &__overlay {
    position: fixed;
    top: ${props => (props.isSmall ? '150px' : '110px')};
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 40;
    background-color: rgba(18, 21, 32, 0.85);
  }
  

  &__content {
    position: absolute;
    top: 40px;
    left: 200px;
    right: 200px;
    bottom: 100px;
    background: white;
    border-radius: 8px;
    padding: 14px 20px 20px 20px;
	
    @media (max-width: 1024px) {
      left: 50px;
      right: 50px;
    }
    @media (max-width: 768px) {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: white;
      border-radius: 0;
    }

    @media (max-width: 420px) {
      padding: 6px 4px 4px 6px;
    }
  }
`
const ModalSearchStatus = styled.span`
	position: absolute;
	height: 1px;
	width: 1px;
	overflow: hidden;
	clip: rect(1px, 1px, 1px, 1px);
	text-indent: -100em; 
	white-space: nowrap;

`
const Search = () => {
  const [searchValue, setSearchValue] = useState('')
  const [showResult, setShowResult] = useState(false)
  const [searchTerm] = useDebounce(searchValue, 300)
  const uiDispatch = useUIDispatch()
  const localeState = useLocaleState()

  const [selectedSearchItem, setSelectedSearchItem] = useState({
    item: null,
    type: null
  })
  
	const {data: buildings} = useViewFetch({
		api: fetchBuildings
	})

  const {data: searchResult, isLoading} = useViewFetch({
    api: fetchSearchResults,
    parameters: searchTerm,
    initialState: {
      bl: [],
	  rm: [],
      //eq: [],

      documents: {}
    },
    onChangeOf: [searchTerm]
  })

  const closeSearchResult = () => {
	  setShowResult(false)
	  document.getElementById('mainApp').setAttribute('aria-hidden','false')
	  
      const allBackgroundElements = document.querySelector("main").querySelectorAll('[tabindex="-1"]') // get first element to be focused inside modal
	    for (const element of allBackgroundElements) {
      element.setAttribute('tabindex', "0")
	    }
      
      document.getElementById('contact-us').removeAttribute('tabindex')
      if(document.getElementById('bl-search-input') != null){
        document.getElementById('bl-search-input').removeAttribute('tabindex')
      }
  }
  
  const  focusableElements = 'button, [role="treeitem"]'
	  
  useEffect(
    () => {
      if (searchTerm) {
        setShowResult(true)
        
        const modal = document.querySelector('#modalContent') // select the modal by it's id
        if (modal != null){
		  modal.removeAttribute("tabindex")
        }

		const allBackgroundElements = document.querySelector("main").querySelectorAll('[tabindex="0"]') // get first element to be focused inside modal
		for (const element of allBackgroundElements) {
	        element.setAttribute('tabindex', "-1")
	    }
		if(document.querySelector("main").querySelector("a")){
			document.querySelector("main").querySelector("a").setAttribute('tabindex', "-1")
		}
		if(document.querySelector("main").querySelector("button")){
			const buttonElements = document.querySelector("main").querySelectorAll("button")
			for (const item of buttonElements) {
				item.setAttribute('tabindex', "-1")
		    }
		}
		document.getElementById('contact-us').setAttribute('tabindex', "-1")
		if(document.getElementById('bl-search-input') != null){
		    document.getElementById('bl-search-input').setAttribute('tabindex', "-1")
		}
      } else {
        setShowResult(false)
        
	        const allBackgroundElements = document.querySelector("main").querySelectorAll('[tabindex="-1"]') // get first element to be focused inside modal
		    for (const element of allBackgroundElements) {
	        element.setAttribute('tabindex', "0")
		    }
	        
	        document.getElementById('contact-us').removeAttribute('tabindex')
	        if(document.getElementById('bl-search-input') != null){
	          document.getElementById('bl-search-input').removeAttribute('tabindex')
	        }
      }
    },
    [searchTerm, isLoading]
  )

  useEffect(
    () => {
      const {type, item} = selectedSearchItem

      if (type) {
        uiDispatch({
          type: 'showSearch',
          payload: {show: true, type, options: item}
        })
      }
    },
    [selectedSearchItem, uiDispatch]
  )

  const getPlaceHolderText = () => {
    let placeHolderText = ''
    if (window.matchMedia('(max-width: 1023px').matches) {
      placeHolderText = _L({
        key: 'Search by Building, Property Code, or Room Number',
        localeState
      })
    } else {
      placeHolderText = _L({
        key: 'Search by Building, Property Code, or Room Number',
        localeState
      })
    }

    return placeHolderText
  }

  const onSearchCancel = evt => {
	  if(evt.key == "Enter" || evt.key == " " || !evt.key){
		  setSearchValue('')
	  }
  }

  const handleAfterOpenFunc = () => {
	  document.getElementById('mainApp').setAttribute('aria-hidden','true')
	  
  }
  
  const onItemSelect = ({type, item, evt}) => {
    if (evt) {
      evt.stopPropagation()
    }

    // Close the search panel
    setSearchValue('')
    setShowResult(false)
	
	if (type == "bl" && buildings.find(function a(blObj) {return blObj.blId == item.blId;}).adaFloors == 0)
	{
		if (confirm("Information about the building you selected is not currently available on this site.\n\nSelect 'OK' to open a new tab and view building data from the old web site.\n"))
		{
		  window.open("http://ada.fs.illinois.edu/"+item.blId+".html")
		}
	}
	else
	{
		setSelectedSearchItem({type, item})
	}
//	setSelectedSearchItem({type, item})
  }
  let modalSearchCount = ""
	  
  if (searchTerm != ""){
		  let searchLength = searchResult.bl.length + searchResult.rm.length /*+ searchResult.eq.length*/
		  if (searchResult.bl.length == 20 || searchResult.rm.length == 20 /*|| searchResult.eq.length == 20*/){
			  modalSearchCount = searchLength + "+ Results"	
		  }else{
			  modalSearchCount = searchLength + " Results"			  
		  }
  }
  else {modalSearchCount = ""}
	  
  return (
    <div>
      <SearchInput
        value={searchValue}
        onSearchChange={e => setSearchValue(e.target.value)}
        placeholder={getPlaceHolderText()}
        onCancel={onSearchCancel}
        onKeyDown={onSearchCancel}
      />
      <ModalSearchStatus role="status" id="search-status">{modalSearchCount}</ModalSearchStatus>
      <MediaQuery maxWidth={420}>
        {matches => (
          <StyledModal
            isOpen={showResult}
            onAfterOpen={handleAfterOpenFunc}
            ariaHideApp={false}
            shouldFocusAfterRender={false}
            onRequestClose={closeSearchResult}
            shouldCloseOnOverlayClick
            isSmall={matches}
          >
            <SearchResult
              data={searchResult}
              onItemSelect={onItemSelect}
              searchTerm={searchTerm}
              isSmall={matches}
              isLoading={isLoading}
            />
          </StyledModal>
        )}
      </MediaQuery>
    </div>
  )
}

export default Search
